<template>
  <div id="cooperateinkage">
    <div class="mt-4">
      <template>
        <van-button
          type="info"
          size="small"
          class="w-25"
          round
          @click="pushUserInfo"
          >添 加</van-button
        >
      </template>
      <div>
        <el-form
          label-width="35%"
          label-position="left"
          class="m-4 text-left"
          v-for="(item, index) in userList"
          :key="index"
        >
          <el-form-item size="mini">
            <template slot="label">
              <i class="fa fa-fw fa-user"></i>
              姓名
            </template>
            <template>{{ item.UserName }}</template>
          </el-form-item>
          <el-form-item size="mini">
            <template slot="label">
              <i class="fa fa-fw fa-map-marker"></i>
              职务
            </template>
            <template>{{ item.DutyName }}</template>
          </el-form-item>
          <el-form-item size="mini">
            <template slot="label">
              <i class="fa fa-fw el-icon-phone"></i>
              固定电话
            </template>
            <template>{{ item.UserTelephone }}</template>
          </el-form-item>
          <el-form-item size="mini">
            <template slot="label">
              <i class="fa fa-fw el-icon-mobile-phone"></i>
              手机号
            </template>
            <template>{{ item.UserPhone }}</template>
          </el-form-item>
          <el-form-item size="mini">
            <van-button
              type="info"
              size="small"
              @click="
                getUserInfo(
                  item.UserID
                )
              "
              >编 辑</van-button
            >
            <van-button
              type="danger"
              style="margin-left: 10px"
              size="small"
              @click="removeUser(item.UserID)"
              >删 除</van-button
            >
          </el-form-item>
        </el-form>
        <div class="m-4 pb-4"></div>
      </div>
    </div>
    <!-- 添加人员弹出框 -->
    <el-dialog
      title="添加考务值班人员"
      :visible.sync="dialogVisible"
      width="90%"
      :before-close="handleClose"
      z-index="100"
    >
      <span>
        <el-form label-width="40%" label-position="left" class="m-4 text-left">
          <el-form-item size="mini">
            <template slot="label">
              <span style="color: red">*</span>
              姓名
            </template>
            <template>
              <el-input type="text" v-model="UserName" size="mini"></el-input>
            </template>
          </el-form-item>
          <el-form-item size="mini">
            <template slot="label">
              <span style="color: red">*</span>
              职务
            </template>
            <template>
              <el-input type="text" v-model="DutyName" size="mini"></el-input>
            </template>
          </el-form-item>
          <el-form-item size="mini">
            <template slot="label">
              <span style="color: red">*</span>
              固定电话
            </template>
            <template>
              <el-input type="text" v-model="UserTelephone" size="mini"></el-input>
            </template>
          </el-form-item>
          <el-form-item size="mini">
            <template slot="label">
              <span style="color: red">*</span>
              手机号
            </template>
            <template>
              <el-input type="text" v-model="UserPhone" size="mini"></el-input>
            </template>
          </el-form-item>
        </el-form>
      </span>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="preserve">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 編輯彈窗 -->
    <el-dialog
      title="编辑考务值班人员"
      :visible.sync="dialogShow"
      width="90%"
      :before-close="handleClose"
      z-index="100"
    >
      <span>
        <el-form label-width="40%" label-position="left" class="m-2 text-left">
          <el-form-item size="mini">
            <template slot="label">
              <span style="color: red">*</span>
              姓名
            </template>
            <template>
              <el-input
                type="text"
                v-model="userInfo.UserName"
                size="mini"
              ></el-input>
            </template>
          </el-form-item>
          <el-form-item size="mini">
            <template slot="label">
              <span style="color: red">*</span>
              职务
            </template>
            <template>
              <el-input
                type="text"
                v-model="userInfo.DutyName"
                size="mini"
              ></el-input>
            </template>
          </el-form-item>
          <el-form-item size="mini">
            <template slot="label">
              <span style="color: red">*</span>
              固定电话
            </template>
            <template>
              <el-input
                type="text"
                v-model="userInfo.UserTelephone"
                size="mini"
              ></el-input>
            </template>
          </el-form-item>
          <el-form-item size="mini">
            <template slot="label">
              <span style="color: red">*</span>
              手机号
            </template>
            <template>
              <el-input
                type="text"
                v-model="userInfo.UserPhone"
                size="mini"
              ></el-input>
            </template>
          </el-form-item>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogShow = false">取 消</el-button>
        <el-button type="primary" @click="setUserInfo">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 加载数据时显示遮罩层 -->
    <van-overlay :show="overlayshow">
      <div class="wrapper">
        <van-loading vertical>工作任务加载中...</van-loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { Dialog } from "vant";
export default {
  name: "dutyperson",
  data () {
    return {
      aaaaa: "",
      RollleaderID: -1,
      userList: [],
      dataId: {
        WorkID: this.getWork().WorkID
      },
      userNumList: [],
      userInfo: {},
      dialogVisible: false,
      dialogShow: false, //編輯彈窗是否顯示
      overlayshow: false, // 遮罩层
      UserName: "",
      UserTelephone: "",
      UserPhone: "",
      DutyName: "", //职务
    };
  },
  created () {
    this.fetchData();
    this.completeBtnAttribute.tips = "需要先添加考务值班人员信息后上报状态";
    this.verifiupdateData();
  },
  watch: {},
  props: {
    SplitProcessID: String, //分解环节ID
    ProcessData: Object, //工作环节数据
    ProcessRefresh: Function, //工作环节刷新事件
    completeBtnAttribute: Object //工作环节上报完成按钮
  },
  methods: {
    fetchData () {
      this.userList = [];
      this.apiGetDutyPersonList (
        {
          WorkID: this.getWork().WorkID,
          SplitProcessID: this.SplitProcessID
        },
        this,
        res => {
          this.userList=res.data;
        }
      );
      this.verifiupdateData();
    },
    // 添加按鈕  显示弹窗
    pushUserInfo () {
      this.dialogVisible = true;
    },
    // 編輯按鈕
    getUserInfo (UserID) {
      this.dialogShow = true;
      this.apiGetDutyPersonInfo(
        {
          WorkID: this.getWork().WorkID,
          UserID: UserID
        },
        this,
        res => {
          this.userInfo = res.data;
        }
      );
    },
    // 添加值班人员  保存按鈕
    preserve () {
      if (this.UserName == "") {
        Dialog.alert({
          title: "提示",
          message: "姓名不能为空"
        }).then(() => {
          // on close
        });
      } else if (this.UserTelephone == "") {
        Dialog.alert({
          title: "提示",
          message: "固定电话不能为空"
        }).then(() => {
          // on close
        });
      } else if (this.DutyName == "") {
        Dialog.alert({
          title: "提示",
          message: "职务不能为空"
        }).then(() => {
          // on close
        });
      } else if (this.UserPhone == "") {
        Dialog.alert({
          title: "提示",
          message: "手机号不能为空"
        }).then(() => {
          // on close
        });
      } else {
        this.overlayshow = true; // 显示遮罩层
        this.apiAddDutyPersonInfo(
          {
            WorkID: this.getWork().WorkID,
            SplitProcessID: this.SplitProcessID,
            UserName: this.UserName,
            DutyName: this.DutyName,
            UserTelephone: this.UserTelephone,
            UserPhone: this.UserPhone
          },
          this,
          res => {
            this.overlayshow = false; // 显示遮罩层
            if (res.code == 20000) {
              this.dialogVisible = false;
              this.UserName = "";
              this.UserTelephone = "";
              this.UserPhone = "";
              this.DutyName = "";
              this.$message({
                message: res.message,
                type: "success"
              });
              this.fetchData();
            } else {
              this.$toast(res.message);
            }
            if (res.code == 50000) {
              this.dialogVisible = false;
              this.$message.error(res.message);
              this.fetchData();
              return;
            }
          }
        );
      }
    },
    // 编辑工作人员  保存按鈕
    setUserInfo () {
      if (this.userInfo.DutyName == "") {
        Dialog.alert({
          title: "提示",
          message: "职务不能为空"
        }).then(() => {
          // on close
        });
      } else if (this.userInfo.UserTelephone == "") {
        Dialog.alert({
          title: "提示",
          message: "固定电话不能为空"
        }).then(() => {
          // on close
        });
      } else if (this.userInfo.UserPhone == "") {
        Dialog.alert({
          title: "提示",
          message: "手机号不能为空"
        }).then(() => {
          // on close
        });
      } else if (this.userInfo.UserName == "") {
        Dialog.alert({
          title: "提示",
          message: "姓名不能为空"
        }).then(() => {
          // on close
        });
      } else {
        this.apiSetDutyPersonInfo(
          {
            WorkID: this.getWork().WorkID,
            AreaID: this.userInfo.AreaID,
            UserName: this.userInfo.UserName,
            UserPhone: this.userInfo.UserPhone,
            DutyName: this.userInfo.DutyName,
            UserTelephone: this.userInfo.UserTelephone,
            UserID: this.userInfo.UserID
          },
          this,
          res => {
            console.log("res.code:" + res.code)
            if (res.code == 20000) {
              this.$message({
                message: res.message,
                type: "success"
              });
              this.fetchData();
              this.dialogShow = false;
            } else {
              this.$toast(res.message);
            }
            if (res.code == 50000) {
              this.$message.error(res.message);
              this.fetchData();
              return;
            }
          }
        );
      }
    },
    // 刪除工作人員
    removeUser (userID) {
      Dialog.confirm({
        title: "提示",
        message: "此操作将永久删除, 是否继续?"
      })
        .then(() => {
          this.apiDelDutyPersonInfo(
            { WorkID: this.getWork().WorkID, UserID: userID },
            this,
            res => {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.fetchData();
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    handleClose () {
      this.dialogVisible = false;
      this.dialogShow = false;
      this.UserName = "";
      this.UserTelephone = "";
      this.UserPhone = "";
      this.DutyName = "";
    },
    verifiupdateData () {
      this.apiAllowreportDutyPerson(
        {
          WorkID: this.getWork().WorkID,
          SplitProcessID: this.SplitProcessID
        },
        this,
        res => {
          if (res.data == 1) {
            this.completeBtnAttribute.disabled = false;
          } else {
            this.completeBtnAttribute.disabled = true;
          }
        }
      );
    }
  }
};
</script>

<style scoped>
.el-dialog__body {
  padding: 1px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
</style>